import React from 'react';
import PropTypes from 'prop-types';
import FlatJumpsTables from '../../pedigree/relativesTable/FlatJumpsTables';

const Progeny = ({ data }) => (
    <FlatJumpsTables
        data={data}
        disclaimerName="Progeny"
        flatTitle="Flat"
        jumpsTitle="Jumps"
        flatNoData="No progeny results on the Flat in our records"
        jumpsNoData="No progeny results over jumps in our records"
    />
);

Progeny.propTypes = {
    data: PropTypes.shape({
        FLAT: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
        JUMPS: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
    }),
};

export default Progeny;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/dam/DamProgeny.jsx